var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdkLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.51 104.87 180.51 123.57 200.29 104.87 217.2 104.87 196.14 124.89 220.32 155.22 203.53 155.22 203.3 154.63 186.62 133.64 180.51 139.28 180.51 155.22 166.85 155.22 166.85 104.87 180.51 104.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.77,103.26c9.3-.57,19.56,3.08,26.9,8.68l-8.05,8.75c-7.66-5.97-20.03-9.39-27.2-.84-6.67,7.95-3.86,20.99,6.12,24.59,8.41,3.03,16.25-1.07,22.51-6.46l8.06,8.49c-5.03,4.73-11.73,8.13-18.5,9.55-15.14,3.16-31.19-3.33-35.08-19.26-4.2-17.17,7.9-32.44,25.25-33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.72,104.87h-26.97s0,50.35,0,50.35h26.97c31.89-1.7,32.85-48.14,0-50.35ZM140.75,136.44c-4.05,9.36-14,7.25-22.34,7.51v-27.81c3.07.12,6.18-.16,9.24,0,2.87.14,5.67.4,8.18,1.89,5.9,3.48,7.52,12.4,4.92,18.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdkLogoDark);
export default __webpack_public_path__ + "static/media/cdk-logo-dark.13292e143518da060564fc121c060626.svg";
export { ForwardRef as ReactComponent };